const state = {
    editor_pro_id:0,
    acp_token:'',
    version_id: ''
}
const getters = {
    editor_pro_id: state => state.editor_pro_id,
    acp_token: state => state.acp_token,
    version_id: state => state.version_id,
}
const mutations = {
    currentEditorProId(state, update) {
        state.editor_pro_id = update
    },
    currentAcpToken(state, update) {
        state.acp_token = update
    },
    currentVersionId(state, update) {
        state.version_id = update
    },
  };
const actions = {
    setEditorProId({commit}, editor_pro_id) {
        commit('currentEditorProId',editor_pro_id)
    },
    setEditorAcpToken({commit}, token) {
        commit('currentAcpToken',token)
    },
    setEditorVersionId({commit}, version_id) {
        commit('currentVersionId',version_id)
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}
